import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { arrayMove } from "@dnd-kit/sortable";
const initialState = {
  form: {
    _id: "66f66781bce5bcb0422d1b88",
    formTag: [  
      {
        _id: "66f648d6887ae6115c44ae61",
        tagName: "Customer Feedback",
        tagColor: "#039BE6",
        tagIcon: "FaArrowAltCircleDown",
      },
      {
        _id: "66f648eb887ae6115c44ae63",
        tagName: "School Feedback",
        tagColor: "#EC773F",
        tagIcon: "FaArrowAltCircleDown",
      },
      {
        _id: "66f648f1887ae6115c44ae65",
        tagName: "Company Feedback",
        tagColor: "#008080",
        tagIcon: "FaArrowAltCircleDown",
      },
    ],
    formTitle: "Untitled Section",
    formDescription:
      "Lorem Ipsum has been the industry's standard dummy text ever standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    sections: [
      {
        _id: "66b8b2ff57025121dce9ad18",
        id: "container-05205e60-d27d-4c5d-aedb-d720d63cd9f3",
        sectionTitle: "UnTitle section",
        sectionDescription: "undescription",
        questions: [
          {
            _id: "670cc42cb8877c37d60a44e1",
            id: "item-97d7c059-cd54-4952-ad79-be652ca0899b",
            question: "<p>What is you name</p>",
            errorText: "",
            type: "Location",
            order: 0,
            required: false,
            address: [
              {
                type: "address",
                placeHolder: "address line1",
                optionText: " ",
              },
              {
                type: "address",
                placeHolder: "address line2",
                optionText: " ",
              },
              { type: "text", placeHolder: "city", optionText: "" },
              { type: "text", placeHolder: "postal/zip code", optionText: "" },
              {
                type: "text",
                placeHolder: "state/region/province",
                optionText: "",
              },
              { type: "text", placeHolder: "country", optionText: "" },
            ],
            __v: 0,
          },
        ],
      },
    ],
  },
 
};

export const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    createNewForm: (state, action) => {
      state.form = action.payload;
    },
    addAddress: (state, action) => {
      const { text, containerIndex, questionIndex, index } = action.payload;
      console.log(action.payload);
      if (text === "address line1" || text === "address line2") {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].address.splice(index, 0, {
          id: uuidv4(),
          type: "address",
          placeHolder: text,
          optionText: "",
        });
      } else {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].address.splice(index, 0, {
          id: uuidv4(),
          type: "text",
          placeHolder: text,
          optionText: "",
        });
      }
    },
    removeAddress: (state, action) => {
      const { text, containerIndex, questionIndex } = action.payload;

      const question =
        state.form.sections[containerIndex].questions[questionIndex];
      question.address = question.address.filter(
        (addr) => addr.placeHolder !== text
      );
    },
    //craete new Question
    createForm: (state, action) => {
      const { overContainerIndex, newItems } = action.payload;
      state.form.sections[overContainerIndex].questions.push(newItems);
    },
    updateFormOverQuestion: (state, action) => {
      const { overContainerIndex, newItems, overItemIndex } = action.payload;
      state.form.sections[overContainerIndex].questions.splice(
        overItemIndex + 1,
        0,
        newItems
      );
    },
    //updateFormtitle
    updateFormTitle: (state, action) => {
      const { value } = action.payload;
      state.form.formTitle = value;
    },
    //create new section
    createNewSection: (state, action) => {
      const { overContainerIndex, overItemIndex } = action.payload;
      const oldArray = state.form.sections[overContainerIndex].questions.slice(
        0,
        overItemIndex
      );

      const newArray =
        state.form.sections[overContainerIndex].questions.slice(overItemIndex);
      state.form.sections[overContainerIndex].questions = oldArray;
      state.form.sections.push({
        id: `container-${uuidv4()}`,
        sectionTitle: "New Container",
        sectionDescription:
          "Lorem Ipsum has been the industry's standard dummy text ever standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        questions: newArray,
      });
    },

    // remove section (baskar added)
    removeSection: (state, action) => {
      const { containerIndex, mergeIntoIndex = null } = action.payload;
      if (containerIndex < 0 || containerIndex >= state.form.sections.length) {
        return;
      }
      const removedSection = state.form.sections[containerIndex];
      if (
        mergeIntoIndex !== null &&
        mergeIntoIndex >= 0 &&
        mergeIntoIndex < state.form.sections.length
      ) {
        state.form.sections[mergeIntoIndex].questions = [
          ...state.form.sections[mergeIntoIndex].questions,
          ...removedSection.questions,
        ];
      }
      state.form.sections.splice(containerIndex, 1);
    },

    //move question within a section
    MoveQuestion: (state, action) => {
      const {
        activeContainerIndex,
        overContainerIndex,
        activeitemIndex,
        overitemIndex,
      } = action.payload;
      const [removeditem] = state.form.sections[
        activeContainerIndex
      ].questions.splice(activeitemIndex, 1);
      state.form.sections[overContainerIndex].questions.splice(
        overitemIndex,
        0,
        removeditem
      );
    },

    //move question empty section
    emptysectionmove: (state, action) => {
      const { activeContainerIndex, overContainerIndex, activeitemIndex } =
        action.payload;
      const [removeditem] = state.form.sections[
        activeContainerIndex
      ].questions.splice(activeitemIndex, 1);
      state.form.sections[overContainerIndex].questions.push(removeditem);
    },

    // Qyestion DnD
    QuestionDnd: (state, action) => {
      const { activeitemIndex, overitemIndex, activeContainerIndex } =
        action.payload;
      state.form.sections[activeContainerIndex].questions = arrayMove(
        state.form.sections[activeContainerIndex].questions,
        activeitemIndex,
        overitemIndex
      );
    },

    //sectionDND
    sectionDnd: (state, action) => {
      const { activeContainerIndex, overContainerIndex } = action.payload;
      state.form.sections = arrayMove(
        state.form.sections,
        activeContainerIndex,
        overContainerIndex
      );
    },

    //update Question value for each question
    updateItemQuestion: (state, action) => {
      const { containerIndex, questionIndex, newQuestion } = action.payload;
      state.form.sections[containerIndex].questions[questionIndex].question =
        newQuestion;
    },

    //update Required for each question
    updateRequiredChange: (state, action) => {
      const { questionIndex, containerIndex, value } = action.payload;
      state.form.sections[containerIndex].questions[questionIndex].required =
        value;
    },

    //detele question
    deleteQuestion: (state, action) => {
      const { questionI, containerIndex } = action.payload;
      state.form.sections[containerIndex].questions.splice(questionI, 1);
    },

    //update Singele choice option value
    // updateSingleChoiceOp: (state, action) => {
    //   const { optionIndex, questionIndex, containerIndex, option } =
    //     action.payload;
    //   state.form.sections[containerIndex].questions[questionIndex].address[
    //     optionIndex
    //   ].optionText = option;
    // },
    updateSingleChoiceOp: (state, action) => {
      const { optionIndex, questionIndex, containerIndex, option } =
        action.payload;
      state.form.sections[containerIndex].questions[questionIndex].options[
        optionIndex
      ].optionText = option;
    },

    //delete option
    deleteSingleChoiseOption: (state, action) => {
      const { optionIndex, questionIndex, containerIndex } = action.payload;
      state.form.sections[containerIndex].questions[
        questionIndex
      ].options.splice(optionIndex, 1);
    },

    //Add option
    addOptionSingleChoiceop: (state, action) => {
      const { questionIndex, containerIndex } = action.payload;
      const Question =
        state.form.sections[containerIndex].questions[questionIndex];
      state.form.sections[containerIndex].questions[questionIndex].options.push(
        {
          id: `item-${uuidv4()}`,
          optionText: `Option ${Question.options.length + 1}`,
        }
      );
    },
    updateOption: (state, action) => {
      console.log(action.payload);
      const { questionIndex, containerIndex, options } = action.payload;
      state.form.sections[containerIndex].questions[questionIndex].options =
        options;
    },
    //add option from pro
    addOptionSingleChoiceopPro: (state, action) => {
      const { optionIndex, questionIndex, containerIndex } = action.payload;
      const Question =
        state.form.sections[containerIndex].questions[questionIndex];
      state.form.sections[containerIndex].questions[
        questionIndex
      ].options.splice(optionIndex + 1, 0, {
        id: `item-${uuidv4()}`,
        optionText: `Option ${Question.options.length + 1}`,
      });
    },

    //updateOption
    updateOpton: (state, action) => {
      const { selectedOption, questionIndex, containerIndex } = action.payload;
      console.log(action.payload.selectedOption);
      state.form.sections[containerIndex].questions[questionIndex].options =
        selectedOption;
    },

    //updateNumberRanger
    updateNumberRanger: (state, action) => {
      const { value, name, questionIndex, containerIndex } = action.payload;
      if (name === "minRange") {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].minRange.value = value;
      } else if (name === "maxRange") {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].maxRange.value = value;
      } else if (name === "minValue") {
        state.form.sections[containerIndex].questions[questionIndex].minValue =
          value;
      } else if (name === "maxValue") {
        state.form.sections[containerIndex].questions[questionIndex].maxValue =
          value;
      }
    },

    //updateDateAutoFill
    updateDateAutoFill: (state, action) => {
      const { value, containerIndex, questionIndex } = action.payload;
      state.form.sections[containerIndex].questions[
        questionIndex
      ].autofillDate = value;
    },

    //update question in setting function
    updatevalueFrom: (state, action) => {
      const { name, value, containerIndex, questionIndex } = action.payload;
      // console.log(action.payload);
      return {
        ...state,
        form: {
          ...state.form,
          sections: state.form.sections.map((section, idx) =>
            idx === containerIndex
              ? {
                  ...section,
                  questions: section.questions.map((question, qidx) =>
                    qidx === questionIndex
                      ? {
                          ...question,
                          [name]: value,
                        }
                      : question
                  ),
                }
              : section
          ),
        },
      };
    },

    //change option in multiple and check box options
    changeMultipleOption: (state, action) => {
      const { value, optionIndex, containerIndex, questionIndex, name } =
        action.payload;
      if (name === "rowText") {
        state.form.sections[containerIndex].questions[questionIndex].row[
          optionIndex
        ].rowText = value;
      } else if (name === "columnText") {
        state.form.sections[containerIndex].questions[questionIndex].column[
          optionIndex
        ].columnText = value;
      }
    },
    //add option in multiple and check box options
    addMultiChoice: (state, action) => {
      const { questionIndex, containerIndex, text, length } = action.payload;
      if (text === "row") {
        state.form.sections[containerIndex].questions[questionIndex].row.push({
          id: uuidv4(),
          rowText: `Row ${length + 1}`,
        });
      } else if (text === "column") {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].column.push({
          id: uuidv4(),
          columnText: `Column ${length + 1}`,
        });
      }
    },

    //delete option in multiple and check box options
    deleteMultiChoice: (state, action) => {
      const { containerIndex, text, optionIndex, questionIndex } =
        action.payload;
      if (text === "row") {
        state.form.sections[containerIndex].questions[questionIndex].row.splice(
          optionIndex,
          1
        );
      } else if (text === "column") {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].column.splice(optionIndex, 1);
      }
    },

    //add file Format from video\audio upload
    updateFileTypes: (state, action) => {
      const { containerIndex, questionIndex, checkedFileFormat } =
        action.payload;
      state.form.sections[containerIndex].questions[questionIndex].fileTypes =
        checkedFileFormat;
    },
    updateFormTitile: (state, action) => {
      const { value, activeContainerIndex } = action.payload;
      return {
        ...state,
        form: {
          ...state.form,
          sections: state.form.sections.map((section, sI) => {
            if (sI === activeContainerIndex) {
              return {
                ...section,
                sectionTitle: value,
              };
            }
            return section;
          }),
        },
      };
    },

    updateFormDescription: (state, action) => {
      const { value, activeContainerIndex } = action.payload;
      return {
        ...state,
        form: {
          ...state.form,
          sections: state.form.sections.map((section, sI) => {
            if (sI === activeContainerIndex) {
              return {
                ...section,
                sectionDescription: value,
              };
            }
            return section;
          }),
        },
      };
    },

    cloneQuestion: (state, action) => {
      const { id, containerIndex } = action.payload;
      return {
        ...state,
        form: state.form.sections.map((container, cIndex) => {
          if (container.id === containerIndex) {
            return {
              ...container,
              questions: container.questions.filter((item) => {
                return item.id === id;
              }),
            };
          }
          return container;
        }),
      };
    },

    reomveTag: (state, action) => {
      const { tagIndex } = action.payload;
      state.form.formTag.splice(tagIndex, 1);
    },

    addTag: (state, action) => {
      const { selectedTag } = action.payload;
      state.form.formTag.push(selectedTag);
    },
    removeSectionAndQuestion: (state, action) => {
      const { sectionIndex } = action.payload;
      return {
        ...state,
        form: {
          ...state.form,
          sections: state.form.sections.filter(
            (_, sectionIndexs) => sectionIndexs !== sectionIndex
          ),
        },
      };
    },

    //update quiz form post value
    updateQuizPointValue: (state, action) => {
      const { point } = action.payload;
      state.form.generalSettings.quizSettings.questionPointValue = point;
    },
    //update correct answer array for radio
    updateCorrectAnswer: (state, action) => {
      const { questionIndex, containerIndex, option } = action.payload;
      const question =
        state.form.sections[containerIndex].questions[questionIndex]
          .correctAnswer;

      if (question.includes(option)) {
        console.log("hello1");
        state.form.sections[containerIndex].questions[
          questionIndex
        ].correctAnswer = question.filter((item) => item !== option);
      } else {
        state.form.sections[containerIndex].questions[
          questionIndex
        ].correctAnswer.push(option);
      }
    },

    //update feedback
    updateQUestionFeedback: (state, action) => {
      const { questionIndex, containerIndex, name, value } = action.payload;

      state.form.sections[containerIndex].questions[questionIndex][name] =
        value;
    },

    //updatefeedback
    removeFeedback: (state, action) => {
      const { containerIndex, questionIndex, name } = action.payload;
      state.form.sections[containerIndex].questions[questionIndex][name] = "";
    },

    addcorrectAnswer: (state, action) => {
      const { questionIndex, containerIndex } = action.payload;
      state.form.sections[containerIndex].questions[
        questionIndex
      ].correctAnswer.push("");
    },

    deleteAnswer: (state, action) => {
      const { questionIndex, containerIndex, answerindex } = action.payload;
      console.log(action.payload);
      state.form.sections[containerIndex].questions[
        questionIndex
      ].correctAnswer.splice(answerindex, 1);
    },
    updateAnswer: (state, action) => {
      const { questionIndex, containerIndex, answerIndex, answer } =
        action.payload;

      state.form.sections[containerIndex].questions[
        questionIndex
      ].correctAnswer[answerIndex] = answer;
    },
  },
});

export const {
  createForm,
  deleteAnswer,
  updateAnswer,
  removeFeedback,
  addAddress,
  removeAddress,
  createNewSection,
  updateFormOverQuestion,
  addcorrectAnswer,
  MoveQuestion,
  QuestionDnd,
  updateRequiredChange,
  deleteSingleChoiseOption,
  addOptionSingleChoiceop,
  updatevalueFrom,
  addOptionSingleChoiceopPro,
  updateFileTypes,
  updateFormTitile,
  updateFormDescription,
  updateItemQuestion,
  deleteQuestion,
  updateNumberRanger,
  updateOpton,
  emptysectionmove,
  updateOption,
  addMultiChoice,
  sectionDnd,
  deleteMultiChoice,
  changeMultipleOption,
  updateSingleChoiceOp,
  createNewForm,
  updateDateAutoFill,
  reomveTag,
  addTag,
  removeSectionAndQuestion,
  updateFormTitle,
  updateQuizPointValue,
  updateCorrectAnswer,
  updateQUestionFeedback,
  // baskar added
  removeSection
} = formSlice.actions;

export default formSlice.reducer;
